import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import BoxEmployee from '../BoxEmployee';
import Icon from '../Icon';

const OverBoxEmployee = styled(BoxEmployee)`
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('30px')} ${rem('60px')};
  `};
`;

const OverBoxEmployeeEmpty = styled(OverBoxEmployee)`
  max-height: ${rem('145px')};
`;

const BoxHobbie = styled.div`
  margin-bottom: ${rem('10px')};

  ${mediaqueries.greaterThan('tablet')`
      column-count: 2;
      column-gap: ${rem('30px')};
      column-fill: auto;
      max-height: 9rem;
  `};
  ${mediaqueries.greaterThan('desktop')`
      column-count: 1;
  `};
  ${mediaqueries.lessThan('mobile')`
      column-count: 1;
  `};
`;

const ItemHobbie = styled.div`
  margin-bottom: ${rem('5px')};
  break-inside: avoid-column;
  &:last-child {
    margin-bottom: 0;
  }
  ${mediaqueries.greaterThan('desktop')`
    display: block;
    margin-bottom: ${rem('9px')};
    &:last-child {
      margin-bottom: 0;
    }    
  `};
`;

const TitleHobbie = styled.h4`
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  margin: 0;
  padding-right: ${rem('10px')};

  ${mediaqueries.greaterThan('desktop')`
    flex-basis: 37%;
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('15px')};
  `};
`;

const BarHobbie = styled.div`
  background-color: ${props => props.theme.colors.gray};
  color: ${props => props.theme.colors.light};
  display: flex;
  margin: 0;
  max-height: ${rem('18px')};
  position: relative;
  width: 100%;
  max-width: ${rem('300px')};
`;

const BarProgress = styled.span`
  background-color: ${props => props.theme.colors.grayDark};
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: ${props => props.comp * 10}%;
`;

const TextBarHobbie = styled.span`
  font-size: ${rem('12px')};
  position: relative;
  z-index: 1;
  align-self: center;
  margin-left: 0.5rem;
`;

const StyleEditIcon = styled(Icon)`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export {
  OverBoxEmployee,
  OverBoxEmployeeEmpty,
  BoxHobbie,
  ItemHobbie,
  TitleHobbie,
  BarHobbie,
  BarProgress,
  TextBarHobbie,
  StyleEditIcon
};
